module search {
  'use strict';

  export class SearchResultsCtrl {

    public static $inject = [
      '$scope', 
      'searchService',
      '$element',
      'pageMetaService',
      '$mdDialog',
      '$location',
      '$log',
      'anchorNavService',
      '$timeout',
      '$window',
      'partService',
      'libraryService'
    ];

    constructor(
      private $scope: ISearchResultScope,
      private searchService: ISearchService,
      private $element: JQuery,
      private pageMetaService: navigation.IPageMetaService,
      private $mdDialog: ng.material.IDialogService,
      private $location: ng.ILocationService,
      private $log: ng.ILogService,
      private anchorNavService: navigation.IAnchorNavService,
      private $timeout: ng.ITimeoutService,
      private $window: ng.IWindowService,
      private partService: part.IPartService,
      private libraryService: library.ILibraryService
    ) {

      $scope.vm = this;
      $scope.meta = pageMetaService.getPageMeta;

      var init = () => {
        var inputElement = <HTMLInputElement>document.getElementsByClassName("searchQueryInput").item(0);
        if (!inputElement) {
          $timeout(init, 300);
        }
        $timeout(() => { inputElement.focus() }, 300);
      }

      angular.element($window).bind('load', () => {
        init();
      });

      $scope.queryString = $location.search().q;
      $scope.data = <Results>{};

      $scope.pages = [
        { "AllResults": [] },
        { "App": [] },
        { "Ind": [] },
        { "Prod": [] },
        { "Doc": [] },
        { "Img": [] },
        { "Part": [] }
      ];

      $scope.activePages = [
        { "AllResults": 1 },
        { "App": 1 },
        { "Ind": 1 },
        { "Prod": 1 },
        { "Doc": 1 },
        { "Img": 1 },
        { "Part": 1 }
      ];

      if (pglob.RouteData.User) {
        $scope.searchCategories = [
          { 'id': 1, 'name': $scope.meta('hl') == 'D' ? 'Alle Ergebnisse' : 'All Results' }
          , { 'id': 5, 'name': $scope.meta('hl') == 'D' ? 'Dokumente' : 'Documents' }
          , { 'id': 6, 'name': $scope.meta('hl') == 'D' ? 'Artikel' : 'Parts' }
          , { 'id': 4, 'name': $scope.meta('hl') == 'D' ? 'Produkte' : 'Products' }
          , { 'id': 7, 'name': $scope.meta('hl') == 'D' ? 'Bilder' : 'Images' }
          , { 'id': 2, 'name': $scope.meta('hl') == 'D' ? 'Anwendungen' : 'Applications' }
          , { 'id': 3, 'name': $scope.meta('hl') == 'D' ? 'Industrien' : 'Industries' }
        ];
      } else {
        $scope.searchCategories = [
          { 'id': 1, 'name': $scope.meta('hl') == 'D' ? 'Alle Ergebnisse' : 'All Results' }
          , { 'id': 5, 'name': $scope.meta('hl') == 'D' ? 'Dokumente' : 'Documents' }
          , { 'id': 4, 'name': $scope.meta('hl') == 'D' ? 'Produkte' : 'Products' }
          , { 'id': 7, 'name': $scope.meta('hl') == 'D' ? 'Bilder' : 'Images' }
          , { 'id': 2, 'name': $scope.meta('hl') == 'D' ? 'Anwendungen' : 'Applications' }
          , { 'id': 3, 'name': $scope.meta('hl') == 'D' ? 'Industrien' : 'Industries' }
        ];
      }

      $scope.searchMethods = [
        { 'id': 1, 'method': 'searchEverything' },
        { 'id': 2, 'method': 'searchApps' },
        { 'id': 3, 'method': 'searchApps' },
        { 'id': 4, 'method': 'searchAllProducts' },
        { 'id': 5, 'method': 'searchDocs' },
        { 'id': 6, 'method': 'searchParts' },
        { 'id': 7, 'method': 'searchPics' },
      ];

      $scope.callSearchFunction = function () {
        //gotta wait until top level has been changed
        $timeout(() => {
          var id = $scope.selectedTopLevel.id;
          var method = $scope.searchMethods.filter((i) => i.id == id)[0];
          $scope.vm[method.method](1, 10);
        }, 1000);        
      }
      
      $scope.$watch('queryString', (newVal: string, oldVal: string) => {
        if (newVal != oldVal) {
          $location.search({ q: newVal });
          $scope.callSearchFunction();
        }
      });
     
    }

    populatePagination(category: string, totalResults: number, perPage: number) {
      this.$scope.pages[category] = [];
      for (var i = 1; i < Math.ceil(totalResults / perPage) + 1; i++) {
        this.$scope.pages[category].push(i);
      }
    }

    searchEverything(pageNum: number, pageCount: number) {
      if (this.$scope.queryString) {
        this.searchService.searchEverything(this.$scope.queryString, (pageNum - 1) * 10, pageCount).then((response: { data: any }) => {
          this.$scope.data.allResults = response.data;
          this.populatePagination("AllResults", response.data.TotalResults, 10)
          this.$scope.activePages["AllResults"] = pageNum;
        })
      }
    }    

    searchApps(pageNum: number, pageCount: number) {
      if (this.$scope.queryString) {
        this.searchService.searchApplications(this.$scope.queryString, (pageNum - 1) * 10, pageCount).then((response: { data: any }) => {
          this.$scope.data.query = response.data.query;
          this.$scope.data.industries = { Hits: response.data.industries.Hits, Count: response.data.industries.Count };
          this.$scope.data.tasks = { Hits: response.data.tasks.Hits, Count: response.data.tasks.Count };
          this.$scope.data.topResult = response.data.topResult;
          this.populatePagination("App", response.data.tasks.Count, 10);
          this.$scope.activePages["App"] = pageNum;
          this.populatePagination("Ind", response.data.industries.Count, 10);
          this.$scope.activePages["Ind"] = pageNum;
        })
      }
    }

    searchDocs(pageNum: number, pageCount: number) {
      if (this.$scope.queryString) {
        this.searchService.searchLibrary(this.$scope.queryString, (pageNum - 1) * 10, pageCount, false).then((response: { data: any }) => {
          this.$scope.data.documents = { Hits: response.data.Hits, Count: response.data.Count };
          this.populatePagination("Doc", response.data.Count, 10);
          this.$scope.activePages["Doc"] = pageNum;
        })
      }
    }

    searchPics(pageNum: number, pageCount: number) {
      if (this.$scope.queryString) {
        this.searchService.searchLibrary(this.$scope.queryString, (pageNum - 1) * 35, 35, true).then((response: { data: any }) => {
          this.$scope.data.pictures = { Hits: response.data.Hits, Count: response.data.Count };
          this.populatePagination("Img", response.data.Count, 35);
          this.$scope.activePages["Img"] = pageNum;
        })
      }
    }

    searchParts(pageNum: number, pageCount: number) {
      if (this.$scope.queryString && pglob.RouteData.User) {
        this.searchService.searchParts(this.$scope.queryString, (pageNum - 1) * 10, pageCount).then((response: { data: any }) => {
          this.$scope.data.parts = { Hits: response.data.Hits, Count: response.data.Count };          
          this.populatePagination("Part", response.data.Count, 10);
          this.$scope.activePages["Part"] = pageNum;
        })
      }
    }

    searchAllProducts(pageNum: number, pageCount: number) {
      if (this.$scope.queryString) {
        this.searchService.searchAllProducts(this.$scope.queryString, (pageNum - 1) * 10, pageCount).then((response: { data: any }) => {
          this.$scope.data.products = { Hits: response.data.Hits, Count: response.data.Count };          
          this.populatePagination("Prod", response.data.Count, 10);
          this.$scope.activePages["Prod"] = pageNum;
        })
      }
    }

    shortenText(text: string) {
      if (text) {
        var textArray = text.split('');
        if (textArray.length > 200) {
          var textString = textArray.slice(0, 200).join('');
          return textString;
        } else {
          return text;
        }
      } else {
        return '';
      }
    }

    openPartDialog(ev: ng.IAngularEvent, part: Part) {
      ev.preventDefault();
      this.partService.openDialog(part.Id, this.$scope);
    }

    openDocumentDialog(ev: ng.IAngularEvent, Doc: Document) {
      ev.preventDefault();
      this.libraryService.openDialog(Doc.DocumentFileSrcRevId, this.$scope, null);
    }

    
  }

}